var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.939 8.57408C29.939 10.0369 29.293 11.4997 28.3811 12.5552C27.4119 13.7218 25.7401 14.5921 24.41 14.5923C24.2581 14.5923 24.1059 14.5736 24.011 14.5551C23.9921 14.4811 23.954 14.2588 23.954 14.0366C23.954 12.5552 24.7331 11.0924 25.569 10.1665C26.633 8.96296 28.4 8.05558 29.882 8C29.9201 8.16674 29.939 8.37041 29.939 8.57408ZM35.1658 17.7886C35.2028 17.765 35.2281 17.7488 35.2399 17.7399C33.264 14.981 30.2619 14.9067 29.4258 14.9066C28.1483 14.9066 27.0048 15.3483 26.0435 15.7197C25.3464 15.989 24.7451 16.2213 24.2579 16.2213C23.7204 16.2213 23.1051 15.9789 22.4183 15.7084C21.5513 15.3669 20.5705 14.9806 19.489 14.9806C15.8412 14.9806 12.1362 17.9249 12.1362 23.48C12.1362 26.9426 13.5042 30.5904 15.1952 32.9421C16.658 34.9419 17.9311 36.5714 19.755 36.5714C20.62 36.5714 21.2543 36.3091 21.9212 36.0332C22.6607 35.7273 23.4403 35.4048 24.619 35.4048C25.8093 35.4048 26.5208 35.7076 27.2071 35.9996C27.8464 36.2716 28.4639 36.5343 29.426 36.5343C31.4209 36.5343 32.732 34.7753 33.9858 33.0161C35.3919 31.0164 35.9809 29.0535 35.9999 28.961C35.8858 28.9241 32.0669 27.4241 32.0669 23.1838C32.0669 19.7708 34.6684 18.1068 35.1658 17.7886Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d3bec028500247c5400fdfac888560b9.svg";
export { ForwardRef as ReactComponent };